import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";

/**
 * Client for the unified `/api/v1/patient-communication/initiate-call`
 * endpoint on the `patient-communication` service.
 *
 * ONE call from the browser. The backend inspects the authenticated
 * doctor's category, looks up the mapped calling number, and picks
 * a vendor:
 *
 *   • Nutritionist (2) / Physiotherapist (4)  → Aspire  (LiveKit + Echo)
 *   • everyone else                            → SparkTG (existing line)
 *
 * The response is tagged so the caller can branch:
 *
 *   {
 *     vendor: "aspire" | "sparktg",
 *     callerCountryCode: "91",
 *     callerPhoneNo: "9876543285",     // for "Calling from" caption
 *     aspire?:  { transcriptId, callSid, patientId },
 *     sparktg?: { status: "dialing" }
 *   }
 *
 * appointmentId is REQUIRED — phr-frontend always has one in context.
 * Errors from the endpoint bubble up with a `message` field the caller
 * can surface in a dialog.
 */
class PatientCommunicationService {
  constructor() {
    this.apiService = new APIService();
  }

  /**
   * @param {object} body
   *   {patientId, patientCountryCode, patientPhoneNo, appointmentId}
   */
  initiateCall(body, onResponse, onError) {
    const url = APIConfig.patientCommunication.initiateCall;
    return this.apiService.post(url, body, onResponse, onError);
  }
}

export default PatientCommunicationService;
